import React, { useState, useEffect } from "react";
import Marquee from "react-fast-marquee";
import dateFormat from "dateformat";
import {
  Container,
  Row
} from "reactstrap";
import Box from '@mui/material/Box';
import Table from "./Table";

const AuditResultpage = () => {

  const [rollbackinfo, setRollbackinfo] = useState([]);
  useEffect(() => {
    const rollbackID = window.sessionStorage.getItem("rollbackID");
    fetch(`${process.env.REACT_APP_API_URL}/api/rollbackinfoview/${rollbackID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setRollbackinfo(resp[0]))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [hostlist, setlist] = useState([]);
  useEffect(() => {
    const rollbackID = window.sessionStorage.getItem("rollbackID");
    fetch(`${process.env.REACT_APP_API_URL}/api/rollbackoverallview/${rollbackID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setlist(resp[0]))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      {window.localStorage.getItem("audit_run_limit") ===
      "License limitation crossed" ? (
        <Marquee pauseOnHover="false" style={{ color: "red" }}>
          You have utilized all your trail "Audit", Please contact{" "}
          <a
            href="mailto:sales@zippyops.com"
            style={{ marginLeft: "5px", color: "red" }}
          >
            sales@zippyops.com
          </a>{" "}
          for subscription.
        </Marquee>
      ) : (
        ""
      )}
      <Box border={1}>
      <div className="header bg-lightBlue-500 pb-5 pt-8 pt-md-5">
        <div>
          <h3
            className="header d-none text-white d-lg-inline-block ml-5"
            style={{
              fontSize: "24px",
              fontWeight: "810",
            }}
          >
            {" "}
            DETAILED ROLLBACK REPORT{" "}
          </h3>
        </div>
          <h3
            className="header d-none text-white d-lg-inline-block ml-5"
            style={{
              fontSize: "24px",
              fontWeight: "810",
            }}
          >
            {" "}
            Hostname : {rollbackinfo.Hostname} 
            <br />
            <h5
              style={{
                fontSize: "16px",
                color: "#fff",
                fontWeight: "810",
                marginTop: "4px",
              }}
            >
              IP/DNS : {rollbackinfo.IP_DNS}{" "}
            </h5>
            <h5
              style={{
                fontSize: "16px",
                color: "#fff",
                fontWeight: "810",
              }}
            >
              Executed at :{" "}
              {dateFormat(rollbackinfo.Executed_at, "mmmm dS, yyyy h:MM TT ")} (IST){" "}
            </h5>
            <h5
              style={{
                fontSize: "16px",
                color: "#fff",
                fontWeight: "810",
                marginTop: "4px",
              }}
            >
              Platform : {rollbackinfo.Platform}{" "}
            </h5>
            <h5
              style={{
                fontSize: "16px",
                color: "#fff",
                fontWeight: "810",
                marginTop: "4px",
              }}
            >
              Rollback ID : {rollbackinfo.Reference_id}{" "}
            </h5>          
          </h3>
      </div>
      </Box>
        <React.Fragment>
          <Container className="mt--6" fluid>      
            <Row className="mt-6">
              <div className="col">
                <Table
                  component="Rollback"                
                  CisResults={hostlist.Result}
                  overallAudit={rollbackinfo.Overall_audit}
                  failedAudit={rollbackinfo.Failed_audit}
                  passedAudit={rollbackinfo.Passed_audit}
                  hostname={rollbackinfo.Hostname}
                  ipdns={rollbackinfo.IP_DNS}
                  exedate={rollbackinfo.Executed_at}
                  platform={rollbackinfo.Platform} 
                />
              </div>
            </Row>  
          </Container>
        </React.Fragment>
    </>
  );
};
export default AuditResultpage;